import { useLimitLedgerRemainingQuery } from '../data-access';
import { type WalletMainCurrencies } from '../models';

type ConvertedPrices = {
	[key: string]: {
		remainingAmountBeforeLimit: number | string;
	};
};

export const useWithdrawRemainingLimit = (currencies?: WalletMainCurrencies) => {
	const defaultCurrencyId = currencies?.defaultCurrency?.id ? currencies.defaultCurrency?.id : '';
	const altCurrencyId = currencies?.altCurrency?.id ? currencies.altCurrency?.id : '';

	const limits = useLimitLedgerRemainingQuery({
		batchType: 'withdrawal',
		'convertAmountToCurrencies[]':
			defaultCurrencyId && altCurrencyId ? [defaultCurrencyId, altCurrencyId] : undefined,
		currencyId: defaultCurrencyId,
		movementType: 'debit'
	});

	const convertedPrices = limits.data?.convertedPrices as ConvertedPrices;

	return {
		cryptoLimit: convertedPrices?.[defaultCurrencyId],
		fiatLimit: convertedPrices?.[altCurrencyId]
	};
};
